import { render, staticRenderFns } from "./ClubesDistrito.vue?vue&type=template&id=dacd1ce8&scoped=true"
import script from "./ClubesDistrito.vue?vue&type=script&lang=ts"
export * from "./ClubesDistrito.vue?vue&type=script&lang=ts"
import style0 from "./ClubesDistrito.vue?vue&type=style&index=0&id=dacd1ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacd1ce8",
  null
  
)

export default component.exports